<account-menu [selectedMenu]="6" [me]="me"></account-menu>

<div class="col-lg-9 col-md-9 col-sm-8 content-panel-wrapper no-padding-mobile">

  <h2 class="page-title">Organisation Settings</h2>

  <div class="page-sub-title">Set the desired session types and durations your organisation will provide</div>

  <form [formGroup]="myForm" (ngSubmit)="onSubmit()">
    <div class="col-sm-12 nopadding-mobile">

      <!-- Session Types -->
      <div class="col-sm-12 nopadding-mobile">
        <div class="panel">
          <div class="panel-title">Session Types</div>

          <div class="col-sm-12"><div class="mb-error-fail-alt" *ngIf="!sessionTypeSelected">Please select at least 1 Session Type</div></div>

          <div class="">
            <div class="col-xs-4">
              <div class="profile-sec-wrap">
                <div class="type-sec-icon type-icon-2"><img src="/images/dash-icon-video.png"></div>
                <div class="panel-sub-title-alt">Video</div>

                <!-- Video -->
                <div class="pref-option-check">
                  <div class="checkbox">
                    <label>
                      <input type="checkbox" [formControl]="myForm.controls['videosession']" [checked]="video"
                        (change)="isSessionChecked($event, 'video')">
                      <span class="cr"><i class="cr-icon glyphicon glyphicon-ok"></i></span>
                    </label>
                  </div>
                </div>
              </div>
            </div>

            <!-- Audio -->
            <div class="col-xs-4">
              <div class="profile-sec-wrap">
                <div class="type-sec-icon type-icon-2"><img src="/images/dash-icon-audio.png"></div>
                <div class="panel-sub-title-alt">Audio</div>

                <div class="pref-option-check">
                  <div class="checkbox">
                    <label>
                      <input type="checkbox" [formControl]="myForm.controls['audiosession']" [checked]="audio"
                        (change)="isSessionChecked($event, 'audio')">
                      <span class="cr"><i class="cr-icon glyphicon glyphicon-ok"></i></span>
                    </label>
                  </div>
                </div>
              </div>
            </div>

            <!-- Messaging -->
            <div class="col-xs-4">
              <div class="profile-sec-wrap">
                <div class="type-sec-icon type-icon-2"><img src="/images/dash-icon-messa.png"></div>
                <div class="panel-sub-title-alt">Messaging</div>

                <div class="pref-option-check">
                  <div class="checkbox">
                    <label>
                      <input type="checkbox" [formControl]="myForm.controls['messagingsession']" [checked]="im"
                        (change)="isSessionChecked($event, 'im')">
                      <span class="cr"><i class="cr-icon glyphicon glyphicon-ok"></i></span>
                    </label>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div class="clear"></div>
        </div>
      </div>

      <div class="clear"></div>

      <!-- Session Duration & Charges -->
      <div class="col-sm-12 nopadding-mobile">
        <div class="panel">

          <div class="panel-title">Session Durations</div>

          <div class="col-sm-12"><div class="mb-error-fail-alt" *ngIf="!sessionDurationSelected">Please select at least 1 Duration</div></div>

          <div>
            <!-- 25 Minute Session -->
            <div class="col-xs-4">
              <div class="profile-sec-wrap">
                <div class="pref-option-check">
                  <div class="checkbox">
                    <label>
                      <input type="checkbox" [formControl]="myForm.controls['session25Valid']"
                        [(ngModel)]="session25Valid" (change)="validateDurationCharges()">
                      <span class="cr"><i class="cr-icon glyphicon glyphicon-ok"></i></span>
                    </label>
                  </div>
                </div>

                <div class="panel-sub-title-alt">25 Minutes</div>
              </div>
            </div>

            <div class="col-xs-4">
              <div class="profile-sec-wrap">
                <div class="pref-option-check">
                  <div class="checkbox">
                    <label>
                      <input type="checkbox" [formControl]="myForm.controls['session50Valid']"
                        [(ngModel)]="session50Valid" (change)="validateDurationCharges()">
                      <span class="cr"><i class="cr-icon glyphicon glyphicon-ok"></i></span>
                    </label>
                  </div>
                </div>

                <div class="panel-sub-title-alt">50 Minutes</div>
              </div>
            </div>

            <div class="col-xs-4">
              <div class="profile-sec-wrap">
                <div class="pref-option-check">
                  <div class="checkbox">
                    <label>
                      <input type="checkbox" [formControl]="myForm.controls['session80Valid']"
                        [(ngModel)]="session80Valid" (change)="validateDurationCharges()">
                      <span class="cr"><i class="cr-icon glyphicon glyphicon-ok"></i></span>
                    </label>
                  </div>
                </div>

                <div class="panel-sub-title-alt">80 Minutes</div>
              </div>
            </div>

          </div>
        </div>
      </div>

      <div class="clear"></div>
    </div>

    <!-- Submit Buttons -->
    <div class="col-sm-12 form-elem nopadding">
      <div class="col-xs-6">
        <button type="submit" class="btn-main-proceed">Save</button>
      </div>
      <div class="col-xs-6">
        <button type="button" class="btn-main-caution" routerLink="/">Cancel</button>
      </div>
    </div>
  </form>
</div>
